import styled from 'styled-components';

export const StyledContent = styled.div`
  .identity__form {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .identity__field {
    margin: 0 0 16px 0;
    &.with-error {
      &.password {
        margin-bottom: 24px;
      }
    }
    &.current {
      margin-bottom: 36px;
    }
  }
  .identity__small-text {
    margin-top: 30px;
    align-self: center;
  }

  .identity__activate-link {
    font-size: 16px;
  }

  .form-buttom {
    margin: 40px 0 0;
  }

  .identity__password-hits-wrapper {
    margin-top: 10px;
  }
`;
